module.exports = __webpack_public_path__ + "static/media/25-3.632a1f50.mp3";